import axios from '@/components/axios'
import rawAxios from 'axios'

const baseApi = process.env.VUE_APP_APIENDPOINT

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
})

const publicClient = rawAxios.create({
  headers: { 'Content-Type': 'application/json' },
})

export function fetchAgreementByToken(token) {
  return publicClient.get(`${baseApi}/public/digital-agreements/${token}`)
}

export function signAgreement(token, payload) {
  return publicClient.post(`${baseApi}/public/digital-agreements/${token}/sign`, payload)
}

export function rejectAgreement(token, payload) {
  return publicClient.post(`${baseApi}/public/digital-agreements/${token}/reject`, payload)
}

export function fetchChannelPartnerAgreement(uuid) {
  return publicClient.get(`${baseApi}/public/channel-partner-agreements/${uuid}`)
}

export function signChannelPartnerAgreement(uuid, payload) {
  return publicClient.post(`${baseApi}/public/channel-partner-agreements/${uuid}/sign`, payload)
}

export function rejectChannelPartnerAgreement(uuid, payload) {
  return publicClient.post(`${baseApi}/public/channel-partner-agreements/${uuid}/reject`, payload)
}

export function sendDigitalAgreement(payload) {
  return axios({
    method: 'POST',
    url: `${baseApi}/digital-agreements/send`,
    headers: authHeaders(),
    data: payload,
  })
}

export function listDigitalAgreements(params) {
  return axios({
    method: 'GET',
    url: `${baseApi}/digital-agreements`,
    headers: authHeaders(),
    params,
  })
}

export function getDigitalAgreement(id) {
  return axios({
    method: 'GET',
    url: `${baseApi}/digital-agreements/${id}`,
    headers: authHeaders(),
  })
}

export function resendDigitalAgreement(id) {
  return axios({
    method: 'POST',
    url: `${baseApi}/digital-agreements/${id}/resend`,
    headers: authHeaders(),
  })
}

export function resendSignedChannelPartnerAgreement(id) {
  return axios({
    method: 'POST',
    url: `${baseApi}/companyassociatepartner/${id}/resend-signed-agreement`,
    headers: authHeaders(),
  })
}

export function downloadSignedAgreement(id) {
  return axios({
    method: 'GET',
    url: `${baseApi}/digital-agreements/${id}/download`,
    headers: authHeaders(),
    responseType: 'blob',
  })
}
